import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {environment} from '../../environments/environment';
import { CommonService } from '../_services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public logo: string = environment.logo;
  production = environment.production;
  stateCode = environment.stateCode;
  public currentRoute = 'dashboard';
  userData:any = [];
  userName = null;
  userLevel = null;
  constructor(private router: Router, private _service: CommonService) { }

  ngOnInit() {
    this.currentRoute = this.router.url.replace('/', '');
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
        this.userName = this.userData['user_profile_id'];
        this.userLevel = this.userData['access_level'];
    }
  }

  logout() {
    const token = localStorage.getItem('userToken');
    if (token) {
      this._service.postRequestCreator({
        token: token
      }, 'logout', token).subscribe(data => {
        this.removeLocalStorageData();
        console.log('logout success');
      }, error => {
        console.log('Error', error);
        this.removeLocalStorageData();
      });
    } else {
      this.removeLocalStorageData();
    }
  }
  removeLocalStorageData() {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    this.router.navigate(['/login']);

  }
  resetServiceVariable() {
    this._service.ind_id = null;
  }
  isReportActive(): boolean {
    return ['close-report', 'sms-report', 'exceedance-report'].includes(this.currentRoute);
  }
}
